import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPageMemberManagementUpdateContentViewStaffFragmentDoc, SettingsPageMemberManagementUpdateContentViewQueryFragmentDoc } from './SettingsPageMemberManagementUpdateContentView.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SettingsPageMemberManagementUpdateViewQueryVariables = Types.Exact<{
  staffGUID: Types.Scalars['ID']['input'];
}>;


export type SettingsPageMemberManagementUpdateViewQuery = { __typename?: 'Query', staff: { __typename?: 'Staff', guid: string, name?: string | null, email: string, role: Types.StaffRole }, planner?: { __typename?: 'Planner', id: string, email: string } | null, viewer: { __typename?: 'Viewer', staff: { __typename?: 'Staff', guid: string } }, teams: Array<{ __typename?: 'Team', guid: string, name: string }> };

export type UpdateStaffMutationVariables = Types.Exact<{
  input: Types.UpdateStaffInput;
}>;


export type UpdateStaffMutation = { __typename?: 'Mutation', updateStaff: { __typename: 'UpdateStaffErrorNotAuthorityPayload' } | { __typename: 'UpdateStaffSuccessPayload', staff: { __typename?: 'Staff', guid: string } } };


export const SettingsPageMemberManagementUpdateViewDocument = gql`
    query SettingsPageMemberManagementUpdateView($staffGUID: ID!) {
  staff(guid: $staffGUID) {
    ...SettingsPageMemberManagementUpdateContentViewStaff
  }
  ...SettingsPageMemberManagementUpdateContentViewQuery
}
    ${SettingsPageMemberManagementUpdateContentViewStaffFragmentDoc}
${SettingsPageMemberManagementUpdateContentViewQueryFragmentDoc}`;

/**
 * __useSettingsPageMemberManagementUpdateViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageMemberManagementUpdateViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageMemberManagementUpdateViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageMemberManagementUpdateViewQuery({
 *   staffGUID: // value for 'staffGUID'
 * });
 */
export function useSettingsPageMemberManagementUpdateViewQuery(variables: SettingsPageMemberManagementUpdateViewQueryVariables | VueCompositionApi.Ref<SettingsPageMemberManagementUpdateViewQueryVariables> | ReactiveFunction<SettingsPageMemberManagementUpdateViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementUpdateViewQuery, SettingsPageMemberManagementUpdateViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementUpdateViewQuery, SettingsPageMemberManagementUpdateViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementUpdateViewQuery, SettingsPageMemberManagementUpdateViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageMemberManagementUpdateViewQuery, SettingsPageMemberManagementUpdateViewQueryVariables>(SettingsPageMemberManagementUpdateViewDocument, variables, options);
}
export function useSettingsPageMemberManagementUpdateViewLazyQuery(variables?: SettingsPageMemberManagementUpdateViewQueryVariables | VueCompositionApi.Ref<SettingsPageMemberManagementUpdateViewQueryVariables> | ReactiveFunction<SettingsPageMemberManagementUpdateViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementUpdateViewQuery, SettingsPageMemberManagementUpdateViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementUpdateViewQuery, SettingsPageMemberManagementUpdateViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementUpdateViewQuery, SettingsPageMemberManagementUpdateViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageMemberManagementUpdateViewQuery, SettingsPageMemberManagementUpdateViewQueryVariables>(SettingsPageMemberManagementUpdateViewDocument, variables, options);
}
export type SettingsPageMemberManagementUpdateViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageMemberManagementUpdateViewQuery, SettingsPageMemberManagementUpdateViewQueryVariables>;
export const UpdateStaffDocument = gql`
    mutation updateStaff($input: UpdateStaffInput!) {
  updateStaff(input: $input) {
    __typename
    ... on UpdateStaffSuccessPayload {
      staff {
        guid
      }
    }
  }
}
    `;

/**
 * __useUpdateStaffMutation__
 *
 * To run a mutation, you first call `useUpdateStaffMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStaffMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStaffMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStaffMutation(options: VueApolloComposable.UseMutationOptions<UpdateStaffMutation, UpdateStaffMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateStaffMutation, UpdateStaffMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateStaffMutation, UpdateStaffMutationVariables>(UpdateStaffDocument, options);
}
export type UpdateStaffMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateStaffMutation, UpdateStaffMutationVariables>;